import Datatable from '../../../common/datatable/index';
import {history} from '../../../../store';
import {dateFormatUK} from '../../../../utils/commonFunctions';

const columns = [
  {
    prop: 'name',
    title: 'Name',
  },
  {
    prop: 'outlets-linked',
    title: 'Outlets Linked',
    width: '120',
    format(data) {
      return (
        <div className='text-center'>
          {data}
        </div>
      );
    }
  },
  {
    prop: 'created-at',
    title: 'Created at',
    width: '100',
    format(data) {
      return dateFormatUK(data);
    }
  },
];

export default ({
  sizePerPage, currentPage = 1, groups, onPageChange, total = 0, handleRemove, totalPages = 0, download
}) => {
  const actions = [
    {
      label: 'Edit',
      permissions: {
        action: 'update',
        subjectClass: 'Group'
      },
      callback: (row) => {
        history.push(`/admin/groups/${row.id}/edit`);
      }
    },
    {
      label: 'Download',
      callback: (row) => {
        download(row.id, row.attributes.name);
      }
    },
    {
      label: 'Delete',
      permissions: {
        action: 'destroy',
        subjectClass: 'Group'
      },
      callback: row => handleRemove(row.id),
      render: (cell, row) => row.attributes['incentives-linked'] === 0
    }
  ];

  const from = groups.length > 0 ? (1 + ((currentPage - 1) * sizePerPage)) : 0;
  let to = currentPage * sizePerPage;
  to = to > total ? total : to;

  return (
    <div>
      <div className="mg-bottom-30">
        <div className="float-end">
          {from}
          {' '}
          -
          {to}
          {' '}
          of
          {total}
        </div>
      </div>
      <Datatable
        actions={actions}
        columns={columns}
        data={groups || []}
        dataSize={sizePerPage * totalPages}
        hideId
        pagination={{
          page: currentPage,
          sizePerPage,
          onPageChange,
        }}
        remote
      />
    </div>
  );
};
